import { faShield } from '@fortawesome/pro-solid-svg-icons';
import { Button } from '@design-system/components/button/button';
import { Typography } from '@design-system/components/typography/typography';

type Props = {
  onModeration: () => void;
};

export const CommunitiesHeader = ({ onModeration }: Props) => {
  return (
    <header className="flex w-full items-center justify-between gap-4">
      <Typography variant="headline" size="medium">
        Community
      </Typography>
      <Button
        color="primaryTonal"
        leftIcon={faShield}
        gap="m"
        onClick={onModeration}
      >
        Moderation
      </Button>
    </header>
  );
};
